module.exports = __webpack_public_path__ + "img/kuaidi100.4dd0b055.png";